export default __webpack_public_path__ + "static/media/E.f147801b.png";